import React, { useEffect, useState } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import api from '../utils/api'

interface ReCaptchaWrapperProps {
  children: React.ReactNode
}

export interface OnVerifyProps {
  executeRecaptcha?: (action?: string) => Promise<string>
  callback: any
  setError?: (message: string) => void
}

export const onVerify = async ({ executeRecaptcha, setError, callback }: OnVerifyProps) => {
    if (executeRecaptcha) {
        const token = await executeRecaptcha()
        api.post('/wp-json/recaptcha/v1/verify', token).then(({ data: recaptchaData }) => {
            const { score } = JSON.parse(recaptchaData.body)
            if (score > 0.6) {
                callback()
            }
        })
    } else if (setError) {
        setError('There was an issue with reCAPTCHA')
    }
}

const ReCaptchaWrapper = ({ children }: ReCaptchaWrapperProps): JSX.Element => {
    const [siteKey, setSiteKey] = useState(null)

    useEffect(() => {
        api.get('/wp-json/recaptcha/v1').then((response) => {
            setSiteKey(response.data)
        })
    }, [])

    if (siteKey == null) {
        return <React.Fragment>{children}</React.Fragment>
    }
    return <GoogleReCaptchaProvider reCaptchaKey={siteKey}>{children}</GoogleReCaptchaProvider>
}

export default ReCaptchaWrapper
